import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { EventsService } from '../../events/shared/events.service';
import { EventRead } from '../../events/shared/event-read.model';
import { PagedResult } from '../../shared/model/paged-result.model';

@Component({
  selector: 'wl-dashboard-events',
  templateUrl: 'events.component.html',
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardEventsComponent implements OnInit {
  private _eventsService: EventsService;

  public eventsList: Array<EventRead>;
  public totalEventCount: number;
  public showExpandedEventList: boolean;
  public isLoading: boolean;

  public constructor(eventsService: EventsService) {
    this._eventsService = eventsService;
    this.isLoading = true;
  }

  ngOnInit() {
    this.showExpandedEventList = false;

    this.loadEvents();
  }

  public loadEvents(): void {
    if (!this.showExpandedEventList) {
      this._eventsService.getNextFiveOrgEvents().then((data: PagedResult) => {
        this.eventsList = data.Result;
        this.totalEventCount = data.TotalCount;
        this.isLoading = false;
      });
    } else {
      this._eventsService.getUpcomingOrgEventsForSixMonths().then((data: PagedResult) => {
        this.eventsList = data.Result;
        this.totalEventCount = data.TotalCount;
        this.isLoading = false;
      });
    }
  }

  public toggleExpandedEventList(): void {
    this.showExpandedEventList = !this.showExpandedEventList;
    this.loadEvents();
  }
}
